import SessionHandler from "./SessionHandler.js";

export class UserSession extends SessionHandler {
	amDesignator: string = "a.m.";
	dayNames: string[] = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
	dayNamesShort: string[] = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
	decimalSeparator: string = ".";
	domain: string = "OB";
	email: string | null | undefined;
	formats: undefined | Record<string, string>;
	groupSeparator: string | null = null;
	integratedSecurity: boolean = false;
	isDeveloper: boolean = false;
	login: string = "";
	loginType: string | undefined;
	monthNames: string[] = [
		"january",
		"february",
		"march",
		"april",
		"may",
		"june",
		"july",
		"august",
		"september",
		"october",
		"november",
		"december",
		"",
	];
	monthNamesShort: string[] = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "augt", "sep", "oct", "nov", "dec", ""];
	name: string | undefined;
	pmDesignator: string = "p.m.";
	shortDateFormat: string = "dd.MM.yyyy";
	culture: string = "en-GB";
	uiculture: string = "en-GB";

	constructor(userData: any) {
		super();
		this.formats = {};
		Object.assign(this, userData);
	}
}
